import styled from 'styled-components';
import { Field, useField } from 'react-final-form';
import CareTeamMemberItem from './CareTeamMemberItem';
import React, { useState } from 'react';
import { Autocomplete, Box, Chip, TextField } from '@mui/material';
import ListBox from 'components/ListBox';

const PractitionerSelect = (props) => {
  const {
    options,
    placeholder,
    multiple,
    name,
    onScroll,
    defaultValue = [],
    loading,
    inputOnChange,
    ...restProps
  } = props;

  const infiniteScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    const scrollHeight = e.target.scrollHeight;
    const clientHeight = e.target.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - 1) {
      onScroll();
    }
  };

  const getOptionLabel = (option) => {
    if (option?.firstName && option?.lastName) {
      return `${option.firstName} ${option.lastName}`;
    } else if (option?.name?.firstName && option?.name?.lastName) {
      return `${option.name.firstName} ${option.name.lastName}`;
    }
    return '';
  };

  const field = useField(name);

  const [currentOptions, setCurrentOptions] = useState(field.input.value || []);

  const handleDelete = (value) => {
    setCurrentOptions(currentOptions.filter((opt) => opt.id !== value));
    field.input.onChange(currentOptions.filter((opt) => opt.id !== value));
  };

  const addUnique = (value) => {
    let unique = [];
    for (let i = 0; i < value.length; i++) {
      if (!unique.find((item) => item.id === value[i].id)) {
        unique.push(value[i]);
      }
    }
    return unique;
  };

  return (
    <Field name={name}>
      {({ input, meta }) => {
        return (
          <Box
            style={{
              width: '100%',
            }}
          >
            <SMuiAutocomplete
              {...input}
              {...restProps}
              name={name}
              unique
              multiple={multiple}
              placeholder={placeholder}
              options={options}
              loading={loading}
              disableClearable
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onBlur={() => inputOnChange('')}
              getOptionLabel={getOptionLabel}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {getOptionLabel(option)}
                </li>
              )}
              defaultValue={currentOptions}
              value={currentOptions}
              onChange={(event, value) => {
                setCurrentOptions(addUnique(value));
                input.onChange(addUnique(value));
                inputOnChange('');
              }}
              renderTags={() => {}}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={meta.touched && !!meta.error}
                  helperText={meta.touched ? meta.error : ''}
                  variant="outlined"
                  placeholder={placeholder}
                  onChange={(e) => inputOnChange(e.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === 'Backspace' || event.key === 'Delete') {
                      event.stopPropagation();
                    }
                  }}
                />
              )}
              ListboxProps={{ onScroll: (e) => infiniteScroll(e) }}
              ListboxComponent={ListBox}
            />
            <SChipContainer>
              {currentOptions?.map((option, index) => (
                <CareTeamMemberItem
                  key={option.id}
                  option={option}
                  handleRemove={handleDelete}
                />
              ))}
            </SChipContainer>
          </Box>
        );
      }}
    </Field>
  );
};

export default React.memo(PractitionerSelect);

const SChipContainer = styled.div`
  margin-top: 10px;
  max-height: 400px;
  overflow-y: auto;
`;
const SMuiAutocomplete = styled(Autocomplete)`
  width: 100%;
  .MuiOutlinedInput-root {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    height: 45px;
    width: 100%;
    fieldset {
      top: 0;
    }
    legend {
      display: none;
    }
  }
`;
